/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geliver_Status_ShippedInputs */

const tr_geliver_status_shipped = /** @type {(inputs: Geliver_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yolda`)
};

const en_geliver_status_shipped = /** @type {(inputs: Geliver_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In transit`)
};

const de_geliver_status_shipped = /** @type {(inputs: Geliver_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unterwegs`)
};

const ru_geliver_status_shipped = /** @type {(inputs: Geliver_Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`В пути`)
};

/**
* | output |
* | --- |
* | "In transit" |
*
* @param {Geliver_Status_ShippedInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const geliver_status_shipped = /** @type {((inputs?: Geliver_Status_ShippedInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geliver_Status_ShippedInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_geliver_status_shipped(inputs)
	if (locale === "de") return de_geliver_status_shipped(inputs)
	if (locale === "ru") return ru_geliver_status_shipped(inputs)
	return tr_geliver_status_shipped(inputs)
});